import React, {Fragment} from "react";
import PhaseRow from "./PhaseRow";
import PhaseWeeksRow from "./PhaseWeeksRow";
import PhaseSequenceRow from "./PhaseSequenceRow";
import PhaseQuestionRow from "./PhaseQuestionRow";
import PhaseDatesRow from "./PhaseDatesRow";

export default function ({reportAnalytics, filteredQuestions, reportType, enablePtoAnalytics}) {
  return (
    <Fragment>
      {reportAnalytics.phases.map(phase => (
        <table className="phase-table" key={phase.guid}>
          <thead>
          <PhaseRow reportAnalytics={reportAnalytics} phase={phase} enablePtoAnalytics={enablePtoAnalytics}/>
          <PhaseWeeksRow reportAnalytics={reportAnalytics} phase={phase} enablePtoAnalytics={enablePtoAnalytics}/>
          <PhaseSequenceRow reportAnalytics={reportAnalytics} phase={phase} enablePtoAnalytics={enablePtoAnalytics}/>
          <PhaseDatesRow reportAnalytics={reportAnalytics} phase={phase} enablePtoAnalytics={enablePtoAnalytics}/>
          </thead>
          <tbody>
          {filteredQuestions.map(question => (
            <PhaseQuestionRow
              reportAnalytics={reportAnalytics}
              phase={phase}
              question={question}
              reportType={reportType}
              enablePtoAnalytics={enablePtoAnalytics}
            />
          ))}
          </tbody>
        </table>
      ))}
    </Fragment>
  )
}
